import styled from 'styled-components';

const StyledLastSaveDate = styled.div`
  color: #ddd;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
`;

export default StyledLastSaveDate;
